const state = {
  totalPieces: '',
  totalAmount: '',
  groupedByMoneyTypeClaims: []
}

const mutations = {
}

const getters = {
}

const actions = {
  fetchUserClaims: function (context, payload) {
    console.log('Fetching claims for email: ' + payload.email)
    if (!payload.email) {
      return
    }
    context.state.groupedByMoneyTypeClaims = []
    context.state.totalPieces = ''
    context.state.totalAmount = ''

    let calculatedTotalPieces = 0
    let calculatedTotalAmount = 0

    context.rootState.firestoreDB.collection('claims').where('claimEmail', '==', payload.email)
      .get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          let documentData = doc.data()
          for (let eachProp in documentData) {
            let propName = eachProp
            if (propName === 'prizeMoney') {
              let incremented = false
              context.state.groupedByMoneyTypeClaims.forEach(function (groupedByMoneyTypeClaim) {
                if (groupedByMoneyTypeClaim.moneyType === doc.data()[propName]) {
                  groupedByMoneyTypeClaim.pieces = groupedByMoneyTypeClaim.pieces + 1
                  groupedByMoneyTypeClaim.totalAmount = parseInt(groupedByMoneyTypeClaim.totalAmount) + parseInt(doc.data()[propName])
                  // increment
                  incremented = true
                }
              })
              if (!incremented) {
                let groupedByMoneyTypeClaim = {
                  moneyType: doc.data()[propName],
                  pieces: 1,
                  totalAmount: parseInt(doc.data()[propName])
                }
                context.state.groupedByMoneyTypeClaims.push(groupedByMoneyTypeClaim)
              }
            }
          }
        })

        // need to sort this from lowest money type to highest
        context.state.groupedByMoneyTypeClaims.sort((firstParam, secondParam) => {
          if (Number(firstParam.moneyType) < Number(secondParam.moneyType)) {
            return -1
          } else if (Number(firstParam.moneyType) > Number(secondParam.moneyType)) {
            return 1
          }
          return 0
        })

        context.state.groupedByMoneyTypeClaims.forEach(function (groupedByMoneyTypeClaim) {
          calculatedTotalPieces += groupedByMoneyTypeClaim.pieces
          calculatedTotalAmount += groupedByMoneyTypeClaim.totalAmount
        })

        if (calculatedTotalPieces > 0) {
          context.state.totalPieces = calculatedTotalPieces
        }
        if (calculatedTotalAmount > 0) {
          context.state.totalAmount = calculatedTotalAmount
        }
      }).catch(function (err) {
        console.error(err)
      })
  }
}

export default { namespaced: true, state, mutations, actions, getters }



// WEBPACK FOOTER //
// ./src/store/userclaimreportstoremodule.js